import { useState, useEffect } from 'react'

const STYLES = `
:root {
  --bg-r: #050508;
  --bg-panel-r: #0C0E14;
  --border-r: #1A1D2E;
  --primary-r: #00FF88;
  --secondary-r: #3B82F6;
  --alert-r: #F59E0B;
  --danger-r: #EF4444;
  --text-r: #E2E8F0;
  --muted-r: #94A3B8;
  --font-h: 'JetBrains Mono', monospace;
  --font-b: 'IBM Plex Sans', sans-serif;
  --font-m: 'JetBrains Mono', monospace;
}
.r-wrap { background: var(--bg-r); color: var(--text-r); font-family: var(--font-b); min-height: 100vh; padding-bottom: 60px; }
.r-wrap::before { content: ""; position: fixed; top:0; left:0; width:100vw; height:100vh; background-image: linear-gradient(to right,rgba(30,41,59,.25) 1px,transparent 1px),linear-gradient(to bottom,rgba(30,41,59,.25) 1px,transparent 1px); background-size:40px 40px; z-index:0; pointer-events:none; }
.r-inner { position:relative; z-index:1; max-width:1100px; margin:0 auto; padding:40px 24px; }
.r-header { border-bottom:1px solid var(--border-r); padding-bottom:24px; margin-bottom:40px; }
.r-tag { font-family:var(--font-m); font-size:.7rem; color:var(--muted-r); letter-spacing:.2em; text-transform:uppercase; margin-bottom:10px; display:block; }
.r-title { font-family:var(--font-h); font-size:clamp(1.6rem,3vw,2.4rem); font-weight:700; color:var(--text-r); margin:0 0 6px; }
.r-subtitle { font-family:var(--font-m); font-size:.88rem; color:var(--muted-r); }
.r-confidential { display:inline-flex; align-items:center; gap:6px; padding:3px 10px; border:1px solid rgba(239,68,68,.4); background:rgba(239,68,68,.06); color:#EF4444; font-family:var(--font-m); font-size:.68rem; letter-spacing:.15em; text-transform:uppercase; margin-top:12px; }
.r-section { margin-bottom:56px; }
.r-section-title { font-family:var(--font-h); font-size:1.1rem; color:var(--primary-r); margin-bottom:20px; border-left:3px solid var(--primary-r); padding-left:12px; }
.r-panel { background:var(--bg-panel-r); border:1px solid var(--border-r); padding:20px; position:relative; margin-bottom:16px; }
.r-panel::before,.r-panel::after { content:''; position:absolute; width:8px; height:8px; border:1px solid var(--muted-r); transition:border-color .2s; }
.r-panel::before { top:-1px; left:-1px; border-right:none; border-bottom:none; }
.r-panel::after { bottom:-1px; right:-1px; border-left:none; border-top:none; }
.r-grid-kpi { display:grid; grid-template-columns:repeat(auto-fit,minmax(180px,1fr)); gap:1px; background:var(--border-r); border:1px solid var(--border-r); margin-bottom:32px; }
.r-kpi { background:var(--bg-panel-r); padding:20px 18px; }
.r-kpi-val { font-family:var(--font-h); font-size:clamp(1.8rem,3vw,2.6rem); font-weight:700; color:var(--primary-r); line-height:1; letter-spacing:-2px; }
.r-kpi-label { font-family:var(--font-m); font-size:.68rem; color:var(--muted-r); text-transform:uppercase; letter-spacing:.1em; margin-top:6px; }
.r-kpi-sub { font-size:.75rem; color:var(--muted-r); margin-top:4px; font-family:var(--font-m); }
.r-kpi-arrow { color:var(--primary-r); font-size:.72rem; font-family:var(--font-m); margin-top:4px; }
.r-table { width:100%; border-collapse:collapse; font-family:var(--font-b); font-size:.88rem; }
.r-table th { font-family:var(--font-m); font-size:.68rem; color:var(--muted-r); text-transform:uppercase; letter-spacing:.08em; padding:8px 10px; border-bottom:1px solid var(--border-r); text-align:left; }
.r-table td { padding:9px 10px; border-bottom:1px solid var(--border-r); vertical-align:top; }
.r-table tr:hover td { background:rgba(255,255,255,.02); }
.r-table td.num { text-align:right; font-family:var(--font-m); }
.r-table tr.hl td { background:rgba(0,255,136,.05); }
.r-grid-2 { display:grid; grid-template-columns:repeat(auto-fit,minmax(300px,1fr)); gap:16px; }
.r-grid-3 { display:grid; grid-template-columns:repeat(auto-fit,minmax(240px,1fr)); gap:16px; }
.r-callout { padding:14px 18px; border-left:3px solid; font-family:var(--font-m); font-size:.88rem; line-height:1.7; margin:16px 0; background:var(--bg-panel-r); }
.r-callout.green { border-color:var(--primary-r); }
.r-callout.amber { border-color:var(--alert-r); }
.r-callout.red { border-color:var(--danger-r); background:rgba(239,68,68,.06); }
.r-callout.blue { border-color:var(--secondary-r); background:rgba(59,130,246,.05); }
.r-badge { display:inline-flex; align-items:center; gap:5px; padding:2px 8px; font-family:var(--font-m); font-size:.65rem; border:1px solid; letter-spacing:.08em; text-transform:uppercase; margin:2px; }
.r-badge.green { color:var(--primary-r); border-color:rgba(0,255,136,.3); background:rgba(0,255,136,.05); }
.r-badge.red { color:var(--danger-r); border-color:rgba(239,68,68,.3); }
.r-badge.blue { color:var(--secondary-r); border-color:rgba(59,130,246,.3); }
.r-badge.amber { color:var(--alert-r); border-color:rgba(245,158,11,.3); }
.r-dot { width:7px; height:7px; border-radius:50%; display:inline-block; }
.r-dot.green { background:var(--primary-r); box-shadow:0 0 6px var(--primary-r); }
.r-dot.red { background:var(--danger-r); box-shadow:0 0 6px var(--danger-r); }
.r-dot.amber { background:var(--alert-r); box-shadow:0 0 6px var(--alert-r); }
.r-phase { border-left:2px solid var(--border-r); padding-left:20px; margin-bottom:28px; position:relative; }
.r-phase::before { content:''; position:absolute; left:-5px; top:4px; width:8px; height:8px; border-radius:50%; background:var(--primary-r); box-shadow:0 0 8px var(--primary-r); }
.r-phase-date { font-family:var(--font-m); font-size:.7rem; color:var(--primary-r); letter-spacing:.12em; text-transform:uppercase; margin-bottom:4px; }
.r-phase-title { font-family:var(--font-h); font-size:1rem; color:var(--text-r); margin-bottom:8px; }
.r-phase-desc { font-size:.88rem; color:var(--muted-r); line-height:1.7; }
.r-pillar { margin-bottom:32px; }
.r-pillar-header { display:flex; align-items:baseline; justify-content:space-between; gap:12px; flex-wrap:wrap; margin-bottom:12px; padding-bottom:8px; border-bottom:1px solid var(--border-r); }
.r-pillar-num { font-family:var(--font-h); font-size:1.2rem; color:var(--primary-r); }
.r-pillar-title { font-family:var(--font-h); font-size:1rem; color:var(--text-r); }
.r-pillar-sub { font-size:.78rem; color:var(--muted-r); font-family:var(--font-m); }
.r-pillar-progress { font-family:var(--font-m); font-size:.78rem; color:var(--alert-r); }
.r-check-item { display:flex; gap:10px; align-items:flex-start; padding:5px 0; font-size:.84rem; border-bottom:1px solid rgba(26,29,46,.5); }
.r-check-done { color:var(--primary-r); flex-shrink:0; font-family:var(--font-m); }
.r-check-pending { color:var(--muted-r); flex-shrink:0; font-family:var(--font-m); }
.r-progress-bar { height:4px; background:var(--border-r); border-radius:2px; margin-top:10px; }
.r-progress-fill { height:100%; background:var(--primary-r); border-radius:2px; }
.r-footer { margin-top:60px; padding-top:24px; border-top:1px solid var(--border-r); display:flex; justify-content:space-between; align-items:flex-end; flex-wrap:wrap; gap:16px; }
.r-person { display:flex; flex-direction:column; gap:4px; }
.r-person-name { font-family:var(--font-h); font-size:1.1rem; color:var(--text-r); }
.r-person-role { font-family:var(--font-m); font-size:.72rem; color:var(--muted-r); }
.r-footer-stamp { font-family:var(--font-m); font-size:.7rem; color:var(--muted-r); text-align:right; line-height:1.8; }
@media(max-width:700px){
  .r-grid-2,.r-grid-3,.r-grid-kpi { grid-template-columns:1fr; }
  .r-inner { padding:20px 16px; }
}
`

const FASES = [
  {
    date: 'Set–Out/2025 — Fase 1',
    title: 'Entrada no WordPress — primeiros sites',
    desc: 'Padronização WORDPRESS (Elementor, stack de plugins). Fallback Gravity Forms N8N direto implementado. HOT FIX páginas Sorvete + Urgente Wp Check Funil. Primeiro contato formal com os ambientes de produção.',
    tags: ['Elementor', 'GF Fallback', 'Sorvete'],
  },
  {
    date: 'Nov–Dez/2025 — Fase 2',
    title: 'Identificação de vulnerabilidade + WAF + Cloudflare',
    desc: 'Identificado ataque de injeção SEO casino/adulto em páginas blips — vulnerabilidade existia desde 2022 sem detecção. Contido, páginas desindexadas no GSC. Regras Cloudflare implementadas. WAF PHP + JS renovado (WafBlips). Troca de webhooks nos sites via PHP. Relatório CyberSec entregue.',
    tags: ['Vulnerab. 2022 identificada', 'Cloudflare', 'WafBlips', 'CyberSec report'],
  },
  {
    date: 'Jan–Fev/2026 — Fase 3',
    title: '10+ HOT FIXes + WafBlips16 + ScanBlips',
    desc: 'HOT FIXes: organização raiz + login global WP, fallback GF database, PHP sessão, blips.com.br, sorvete, cv, confecção, food, ajuda.blips. RCE confirmado em promo.idealdistribuidora.com — contido. WafBlips16.0 deployado. ScanBlips criado do zero. DevOps: plugins globais padronizados.',
    tags: ['RCE promo.ideal', 'ScanBlips', 'WafBlips16', '10+ hot fixes'],
  },
  {
    date: 'Mar/2026 — Fase 4',
    title: 'Mapeamento estratégico + DevOps estetica',
    desc: 'Material WP + Core + Elementor estudado e documentado. ScanBlips melhorado. Auditoria CyberSec estetica. Migração estetica (5,2 GB) no Hostinger. Levantamento 25 WPs para tombamento + 35 pastas sem WP. Relatório GA4 (13 propriedades) para Fernando (CMO). Criativos V2.',
    tags: ['WP mapeado', 'GA4 13 props', 'ScanBlips v2'],
  },
  {
    date: 'Abr/2026 — Fase 5',
    title: 'DNS + SSL + VPS multi-usuário + dados',
    desc: 'FIX DNS WWW todos os domínios (9 addon domains CNAME→A). SSL fix sites. MU-plugin elementor CSS. Infra VPS multi-usuário com ambientes isolados por função. Google Drive sync via rclone. Relatórios Meta CTR Puro março (Food, Pizza, Sorvete).',
    tags: ['DNS WWW fix', 'SSL', 'VPS', 'rclone'],
  },
  {
    date: '20–24 Abr — Fase 6 — Grande trabalho de dados',
    title: 'SSOT: 4 tabelas, 7 scripts, 5 bugs → 66.359 leads',
    desc: 'GF API morta desde fev/2026 (657→0 leads/mês) descoberta. Trigger SSOT quebrado 4 dias. 11.007 leads sem data corrigidos. Scripts gf_extract + gf_import + fix_fallback. SSOT: 54.286 → 66.359. check_pipedrive.py: 17.678 leads (26,6%) sem Pipedrive. Drip N8N construído — 4.200 leads reinseridos em 3 dias.',
    tags: ['5 bugs', '7 scripts', '+12.073 leads', 'Drip N8N'],
  },
  {
    date: '28 Abr–01 Mai — Fase 7',
    title: 'Sprint WP — 9 sites — stack completo',
    desc: 'LiteSpeed + WebP + robots.txt — 9 sites. MU-plugin stack: lcp-fix + gtm-defer + gf-nodefer + swiper-lazy + gf-autocomplete + waf-blips DEBUG fix. Cloudflare proxy ativo (CF-Ray confirmado). Critical CSS cv. CWV re-audit 280 LPs × mobile + desktop = 560 requests (cwv_final.csv).',
    tags: ['9 sites', 'MU-plugin stack', 'CF-Ray', 'CWV 560 req'],
  },
  {
    date: '08–14 Mai — Fase 8',
    title: 'INC-0508/0512 + CF Cache Hardening + Padronização Final',
    desc: 'INC-2026-0508/0512: backdoors wp-feon.php + wp-console + wordpres-seoeo deletados — vetor FTP confirmado. blips-cf-cache-fix.php v2 corrige admin bar leak (Vary: Cookie) nos 9 sites. CF Cache Rule (Ruleset API) + CF Page Rule wp-admin bypass deployados. MU-plugin stack completo nos 6 domínios restantes. Blog ativado nos 9 sites + blips.com.br/blog redirect. Elementor construcao rollback 4.1.0-dev1→4.0.8. GF 2.10.2 forçado em sorvete. Vanessa admin nos 10 sites.',
    tags: ['INC-0508/0512', 'blips-cf-cache-fix v2', 'CF Cache Rules', 'Blog 9 sites'],
  },
  {
    date: '15–19 Mai — Fase 9',
    title: 'SEO Cleanup + Recuperação de Imagens + Auditoria Multi-VPS',
    desc: '571 URLs spam casino/apostas → HTTP 410 Gone (pizza: 1.215 posts spam deletados). Yoast desativado em 6 sites + redirect 301 sitemap_index.xml → wp-sitemap.xml. robots.txt + Content-Signal deployado em 11 sites. 2.131+ imagens recuperadas via backup 34GB Hostinger (05/abr) com cp -n preservando edições manuais — 5 sites afetados. Vanessa login padronizado vanessa.dantas + Wordfence unlock em 12 sites. Auditoria hardening completa nos 15 sites das 5 VPS — 90% já deployado.',
    tags: ['571 URLs 410', '1.215 posts spam', '2.131+ imgs recuperadas', '15 sites audit'],
  },
  {
    date: '20–31 Mai — Fase 10',
    title: 'Tracking Audit + MU-plugins v2 + SEO noindex + CF Robots Fix',
    desc: 'Tracking audit completo: GTM, GA4, Meta Pixel, CAPI, Cloudflare e Clarity mapeados nos 9 sites — doc entregue ao JP. elementor-video-defer.php → .bak em 7 sites (bloqueava Elementor de renderizar thumbnails YT → LCP catastrófico). CF Managed robots.txt desativado nas 3 zonas — bloqueava ClaudeBot, GPTBot, Google-Extended via prepend CF; Content-Signal corrigido. SEO noindex batch: 42+ páginas sem valor (food, pizza, sorvete, fitness, construcao, confeccao, blips). MU-plugins v2: 26 arquivos consolidados em 8, deploy 9/9 sites. PSI audit 56 LPs + diagnóstico pizza (GTM, YT bg, EAEL).',
    tags: ['Tracking audit 9 sites', 'MU-plugins v2 8 arqs', 'CF robots fix', 'SEO 42+ noindex', 'PSI 56 LPs'],
  },
  {
    date: '01 Jun em diante — Fase 11',
    title: 'Hardening Final + GEO + Inteligência de LPs',
    desc: 'INC-2026-0601: pgAdmin exposto ~21 dias em bd.growth.blips.marketing (desktop mode + rota Traefik sem auth) — BasicAuth aplicado imediatamente. WP Plugins hardening suite: deploy mu-plugins faltando em estetica + confeccao, DISALLOW_FILE_EDIT + feeds RSS off em 15 sites. GEO deploy: llms.txt + robots AI-bots (SEO-09 + SEO-10) em 9 sites. Automação planilha de LPs: 280 LPs mapeadas com CWV triagem automática.',
    tags: ['INC-2026-0601', 'GEO deploy', 'DISALLOW_FILE_EDIT', 'LP sheet automation'],
  },
]

type CheckItem = { text: string; done: boolean; note?: string; risk?: boolean }

const PILLARS: { num: string; title: string; sub: string; done: number; total: number; items: CheckItem[] }[] = [
  {
    num: '01', title: 'Higienização', sub: 'Tirar o que não deveria estar lá',
    done: 22, total: 26,
    items: [
      { text: 'RCE corrigido + casino spam attack remediado', done: true },
      { text: 'estetica: vacuo1.png 18MB deletado', done: true },
      { text: 'pasta backup/ exposta em fitness removida', done: true },
      { text: '9 SQL dumps expostos vuze.com.br deletados (~480MB)', done: true },
      { text: 'cloudflare-turnstile desativado: 9 sites', done: true },
      { text: 'Batch update plugins desatualizados', done: true },
      { text: 'PNGs críticos comprimidos: promo.ideal, cv, sorvete, construcao', done: true },
      { text: 'cv: addon packs Elementor removidos', done: true },
      { text: 'blips.com.br/contato/ — injeção SEO SLOT138 limpo', done: true },
      { text: '#281 promo.ideal: 26 → 12 plugins (duplicatas)', done: true },
      { text: 'INC-2026-0512: webshell adicional deletado', done: true },
      { text: 'Tombamento loja.blips.com.br + loja.idealdistribuidora.com', done: true },
      { text: 'ajuda.blips.com.br: SSO functions.php auditado — sem injeção', done: true },
      { text: '571 URLs spam casino/apostas → HTTP 410 Gone', done: true },
      { text: 'pizza.blips.com.br: 1.215 posts spam deletados', done: true },
      { text: '2.131+ imagens recuperadas via backup 34GB', done: true },
      { text: 'Tombamentos validados nas 5 VPS: 6 instâncias removidas', done: true },
      { text: 'SEO noindex batch: 42+ páginas sem valor (7 sites)', done: true },
      { text: '#277 Orphan forms GF: 88 promo.ideal, 15 fitness, 13 food', done: false },
      { text: '#284 Migrar estetica: blips03 → blips01', done: false, risk: true },
      { text: '#285 Migrar promo.ideal: blips02 → blips01', done: false, risk: true },
      { text: '#290 GSC Disavow: backlinks tóxicos (casino + adulto)', done: false },
      { text: 'Limpeza GSC /apostar/ + rotação 4 contas FTP blips01', done: false },
      { text: 'Recuperação imagens críticas construcao (escavadeiras 2026)', done: false },
    ],
  },
  {
    num: '02', title: 'Padronização', sub: 'Como as coisas devem ser em todos os sites',
    done: 28, total: 32,
    items: [
      { text: 'LiteSpeed baseline (js_defer, css_async, js_min, css_min, html_min) → 9/9 sites', done: true },
      { text: 'MU-plugins funil (WAF v16, GF Fallback REST, Make webhook) → 9/9 sites', done: true },
      { text: 'MU-plugins v2: 26 arquivos → 8 consolidados, deploy 9/9 sites', done: true },
      { text: 'DNS WWW fix: 9 addon domains (CNAME → A 212.85.8.242)', done: true },
      { text: 'SSL fix + mixed content: cv.blips.com.br', done: true },
      { text: 'Plugin stack auditada: 8 obrig. / 20 verificar / 8 banidos', done: true },
      { text: '#263 Cloudflare: WAF + Rate Limiting', done: true },
      { text: '#262 Cloudflare DNS proxy ativo: todos os sites — CF-Ray confirmado', done: true },
      { text: 'blips-cf-cache-fix.php v2 — admin bar leak corrigido → 9 sites', done: true },
      { text: 'CF Cache Rule + CF Page Rule wp-admin bypass deployados', done: true },
      { text: 'LiteSpeed exc_cookies: wordpress_logged_in_ configurado', done: true },
      { text: 'MU-plugin stack completo: sorvete, food, pizza, fitness, confeccao, construcao, cv', done: true },
      { text: 'Blog ativado nos 9 sites + blips.com.br/blog redirect', done: true },
      { text: 'robots.txt + Content-Signal padronizado: 11 sites (+ promo.ideal)', done: true },
      { text: 'Yoast desativado em 6 sites + redirect 301 sitemap_index → wp-sitemap.xml', done: true },
      { text: 'Vanessa login padronizado vanessa.dantas + Wordfence unlock: 12 sites', done: true },
      { text: '#278 blips-security.php — XML-RPC bloqueado + headers HTTP em 8/8 LPs (~95%)', done: true },
      { text: '#279 blips-lp-hardening.php — REST /users protegido (HTTP 401): 12/12 sites (~50%)', done: true },
      { text: '#280 MU-Plugins hardening: block-xmlrpc + waf-blips + security-monitor: 12 sites (~90%)', done: true },
      { text: 'DISALLOW_FILE_EDIT em wp-config: 15 sites', done: true },
      { text: 'Feeds RSS/Atom off (HTTP 410): 16 sites', done: true },
      { text: 'Tracking audit: GTM, GA4, Meta Pixel, CAPI, CF mapeados 9 sites', done: true },
      { text: 'elementor-video-defer.php → .bak 7 sites (fix LCP catastrófico)', done: true },
      { text: 'CF Managed robots.txt desativado 3 zonas (desbloqueou AI bots)', done: true },
      { text: '#271 Implementar slug policy nas LPs novas', done: false },
      { text: '#272 301 redirects slugs legados', done: false },
      { text: '#267 EAEL: desabilitar elementos não usados nos 9 sites', done: false },
      { text: '#275 Stack formal por tipo de site: atualizar docs', done: false },
      { text: 'Clarity: implementar nos 9 sites (heatmap + session)', done: false },
      { text: 'GA4 via GTM: confirmar disparo em food, pizza, fitness, cv, estetica, promo', done: false },
      { text: 'CAPI: estender server-side tracking além do fitness', done: false },
      { text: 'Evento Lead GF → Meta: confirmar triggers nos GTM containers', done: false },
    ],
  },
  {
    num: '03', title: 'Mensuração', sub: 'Ver o que está acontecendo de fato',
    done: 11, total: 16,
    items: [
      { text: 'Inventário completo: 36 plugins × 9 sites mapeados', done: true },
      { text: 'Audit GF forms: widget map + orphan forms por site', done: true },
      { text: '280 LPs mapeadas em blips_lps.csv (segmento, form, CWV)', done: true },
      { text: 'CWV audit completo (cwv_results.csv)', done: true },
      { text: 'CWV re-audit pós-deploy: 280 LPs × mobile + desktop = 560 requests', done: true },
      { text: 'Auditoria hardening multi-VPS: 15 sites × 5 VPS — 90% deployado', done: true },
      { text: 'CWV continuidade Mai/2026: 254 LPs — 75% melhoraram, TTFB 66× mais rápido', done: true },
      { text: 'Inventário plugins consolidado: 15 sites — Top 10 consolidáveis identificados', done: true },
      { text: 'Acompanhamento GSC pós-incidente: sitemaps + Content-Signal em 11 sites', done: true },
      { text: 'Automação planilha LPs: 280 LPs com CWV triagem automática (Jun/2026)', done: true },
      { text: 'PSI audit 56 LPs + diagnóstico pizza (GTM, YT bg, EAEL)', done: true },
      { text: '#287 Fix JS GF forms: view só no 1º preenchimento/click', done: false },
      { text: 'Clarity: instalar nos 9 sites (zero cobertura atual)', done: false },
      { text: '#273 Mapa URL → form_id vivo e atualizado', done: false },
      { text: '#249 ScanBlips v5 deploy em blips01', done: false },
      { text: 'Mensuração análise JP + Saleops credenciais', done: false },
    ],
  },
  {
    num: '04', title: 'Otimização', sub: 'Só após limpo, padrão e visível',
    done: 19, total: 21,
    items: [
      { text: 'PHP 8.3: cv.blips.com.br + promo.idealdistribuidora.com → 8.3.30', done: true },
      { text: 'Search Console: páginas casino desindexadas', done: true },
      { text: 'JS defer + CSS async: cv + 9/9 sites (LiteSpeed)', done: true },
      { text: 'Compressão PNGs críticos: promo.ideal (33MB), cv (16MB), sorvete (17MB), construcao (14MB)', done: true },
      { text: 'WebP automático: todos os 9 sites', done: true },
      { text: 'Lighthouse audit: 9 sites — JS errors corrigidos', done: true },
      { text: 'MU-plugin stack CWV: lcp-fix + gtm-defer + gf-nodefer + swiper-lazy → 9/9 sites', done: true },
      { text: 'gf-autocomplete.php (nome/tel/email/empresa) → 9/9 sites', done: true },
      { text: 'waf-blips.php DEBUG=false corrigido → 9/9 sites (estava exposto em produção)', done: true },
      { text: 'TBT cv: audit completo realizado', done: true },
      { text: 'Critical CSS: cv.blips.com.br — above-the-fold inline, resto defer', done: true },
      { text: 'Elementor construcao: rollback 4.1.0-dev1 → 4.0.8 estável', done: true },
      { text: 'GF 2.10.2 forçado em sorvete + domínio re-registrado na conta GF', done: true },
      { text: 'CWV re-audit Mai/2026: 75% das 254 LPs melhoraram — TTFB 3.300ms → 50ms (66×)', done: true },
      { text: 'GEO deploy: llms.txt + robots AI-bots — 9 sites (Jun/2026)', done: true },
      { text: 'INC-2026-0601 pgAdmin: BasicAuth aplicado, container isolado', done: true },
      { text: '#255 fitness: TBT worst case 6.8s em algumas LPs — investigar', done: false },
      { text: '#269 QUIC.cloud: WebP auto + Critical CSS (avaliar custo CDN)', done: false },
    ],
  },
]

const LEDGER = [
  { cat: 'A', nome: 'Segurança e Incidentes', destaques: 'INC-0508/0512/0601, 3 backdoors, WAF, hardening 5 VPS', n: 19 },
  { cat: 'B', nome: 'Cache Stack (CF + LiteSpeed)', destaques: 'Cookie por logado (designers em tempo real), Cache Rules, Zone ID nativo', n: 8 },
  { cat: 'C', nome: 'Performance / CWV', destaques: 'Audit 280 LPs, lcp-fix, WebP, PSI 56 LPs, elementor-video-defer cleanup', n: 14 },
  { cat: 'D', nome: 'Forms / LGPD / GF', destaques: 'Campo LGPD 9 sites, gf-nodefer, GF 2.10.2', n: 7 },
  { cat: 'E', nome: 'SEO + GEO', destaques: 'Plano 3 pilares, CF robots fix (AI bots), 331+ URLs spam, noindex 42+ págs, llms.txt', n: 11 },
  { cat: 'F', nome: 'Tombamentos e Limpeza', destaques: 'loja.blips, loja.ideal, rollback Elementor, 26→12 plugins', n: 8 },
  { cat: 'G', nome: 'Documentação', destaques: 'infra-kb, inventory, standard-stack, handoffs, guias CWV, tracking audit doc', n: 8 },
  { cat: 'H', nome: 'Métricas e Análise', destaques: '280 LPs CSV, 2.125 ads mapeados, funil pipeline, LP sheet automation', n: 7 },
]

const CWV_METRICS = [
  { metrica: 'TTFB médio', antes: '~3.300ms', agora: '50ms', frame: '66× mais rápido' },
  { metrica: 'LCP (top páginas)', antes: '10–11s', agora: '3–5s', frame: 'usuário espera 6s a menos' },
  { metrica: 'Score mobile (top 30 LPs)', antes: '48', agora: '72', frame: '+50% performance' },
  { metrica: 'Sorvete (melhor segmento)', antes: '61', agora: '79', frame: '+28% — faixa verde Google' },
  { metrica: 'LPs com melhora detectada', antes: '—', agora: '191/254', frame: '75% da base' },
]

const CWV_TOP3 = [
  { page: 'food — Ultracongelador VUZE 10B', antes: 50, agora: 90, lcp: '7.8s → 2.6s' },
  { page: 'fitness — Combo Ontrack', antes: 55, agora: 91, lcp: '10.7s → 3.0s' },
  { page: 'confeccao — Plotter i3200', antes: 50, agora: 85, lcp: '11.4s → 3.5s' },
]

const VPS_AUDIT = [
  { vps: 'blips01 (u637248606)', sites: '12 sites principais', wp: '6.9.4', hardening: '~95%', acao: 'FILE_EDIT + feeds + canonical em 5 sites' },
  { vps: 'blips02 (u437771169)', sites: '1: promo.ideal', wp: '6.9.4', hardening: '~85%', acao: '+ security-monitor' },
  { vps: 'blips03 (u920480595)', sites: '1: estetica (+2 vazias)', wp: '6.9.4', hardening: '~95%', acao: 'migrar → blips01' },
  { vps: 'blips04 (u209847224)', sites: '1: vuze.com.br', wp: '6.5.8 ⚠', hardening: '~30%', acao: 'atualizar WP + hardening + RevSlider/Jetpack' },
  { vps: 'blips05 (u412819359)', sites: '1: tecnicoparceiro.com', wp: '6.0.11 ⚠', hardening: '~30%', acao: 'decidir: atualizar OU tombar' },
]

const PILLAR_COMPACT: { num: string; title: string; sub: string; done: string[]; pending: string[] }[] = [
  {
    num: '01', title: 'Higienização', sub: 'Tirar o que não deveria estar lá',
    done: [
      'RCE promo.ideal + casino SLOT138 remediados',
      '3 backdoors removidos (INC-0508/0512)',
      '9 SQL dumps ~480MB deletados (vuze)',
      '571 URLs casino/apostas → HTTP 410',
      '1.215 posts spam pizza deletados',
      'SEO noindex 42+ páginas sem valor (7 sites)',
    ],
    pending: [
      'GSC Disavow + limpeza /apostar/ (blips.com.br)',
      'Migrar estetica blips03→blips01',
      'Rotação 4 contas FTP blips01 comprometidas',
    ],
  },
  {
    num: '02', title: 'Padronização', sub: 'Como as coisas devem ser em todos os sites',
    done: [
      'MU-plugins v2: 26 arquivos → 8 consolidados, 9/9 sites',
      'CF Cache + LiteSpeed exc_cookies (designers em tempo real)',
      'DISALLOW_FILE_EDIT + feeds off: 15 sites',
      'Tracking audit: GTM/GA4/Meta Pixel/CAPI mapeados 9 sites',
      'CF robots.txt: desativado managed, desbloqueou AI bots',
      'elementor-video-defer.php → .bak 7 sites (fix LCP)',
    ],
    pending: [
      'Clarity: zero sites com heatmap/session recording',
      'CAPI server-side: apenas fitness — estender para outros',
      'Slug policy + 301 redirects legados (cv, food, sorvete)',
    ],
  },
  {
    num: '03', title: 'Mensuração', sub: 'Ver o que está acontecendo de fato',
    done: [
      '280 LPs mapeadas: segmento, form, CWV',
      'CWV re-audit: 560 requests (mobile + desktop)',
      'PSI audit 56 LPs + diagnóstico pizza',
      'Tracking audit: doc completo com gaps e plano',
      '15 sites × 5 VPS: auditoria hardening 90%',
    ],
    pending: [
      'Clarity nos 9 sites (prioridade 1)',
      'GA4 via GTM: confirmar food, pizza, fitness, cv',
      'Mapa URL → form_id vivo automatizado',
    ],
  },
  {
    num: '04', title: 'Otimização', sub: 'Só após limpo, padrão e visível',
    done: [
      'TTFB: 3.300ms → 50ms (66× mais rápido via CF)',
      '75% das 254 LPs melhoraram CWV',
      'LCP top páginas: 10–11s → 3–5s',
      'Score mobile top 30 LPs: 48 → 72 (+50%)',
      'WebP automático + compressão PNGs: 9 sites',
      'GEO deploy: llms.txt + robots AI-bots',
    ],
    pending: [
      'Fitness: TBT 6.8s worst case — investigar scripts',
      'QUIC.cloud: WebP auto + Critical CSS (avaliar)',
    ],
  },
]

function ViewCompact({ totalLedger }: { totalLedger: number }) {
  return (
    <div>
      {/* KPIs */}
      <div className="r-grid-kpi" style={{ marginBottom: 40 }}>
        <div className="r-kpi">
          <div className="r-kpi-val">66.359</div>
          <div className="r-kpi-label">Leads no SSOT</div>
          <div className="r-kpi-sub">era 54.286 (+22%)</div>
        </div>
        <div className="r-kpi">
          <div className="r-kpi-val">{totalLedger}+</div>
          <div className="r-kpi-label">Entregas rastreadas</div>
          <div className="r-kpi-sub">Set/2025–Jun/2026</div>
        </div>
        <div className="r-kpi">
          <div className="r-kpi-val">9</div>
          <div className="r-kpi-label">Sites WordPress</div>
          <div className="r-kpi-sub">LiteSpeed + CF + GF</div>
        </div>
        <div className="r-kpi">
          <div className="r-kpi-val">66×</div>
          <div className="r-kpi-label">TTFB mais rápido</div>
          <div className="r-kpi-sub">3.300ms → 50ms</div>
        </div>
        <div className="r-kpi">
          <div className="r-kpi-val">3</div>
          <div className="r-kpi-label">Incidentes</div>
          <div className="r-kpi-sub">INC-0508/0512/0601</div>
        </div>
      </div>

      {/* 4 QUADROS */}
      <div className="r-section">
        <div className="r-section-title">Plano WordPress — Set/2025–Jun/2026</div>
        <div className="r-grid-2">
          {PILLAR_COMPACT.map(p => {
            const pillar = PILLARS.find(x => x.num === p.num)!
            const pct = Math.round((pillar.done / pillar.total) * 100)
            return (
              <div key={p.num} className="r-panel">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                  <div>
                    <span style={{ fontFamily: 'var(--font-m)', fontSize: '.65rem', color: 'var(--primary-r)', letterSpacing: '.15em', textTransform: 'uppercase' }}>0{p.num}</span>
                    <div style={{ fontFamily: 'var(--font-h)', fontSize: '1rem', color: 'var(--text-r)', marginTop: 2 }}>{p.title}</div>
                    <div style={{ fontFamily: 'var(--font-m)', fontSize: '.7rem', color: 'var(--muted-r)', marginTop: 2 }}>{p.sub}</div>
                  </div>
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ fontFamily: 'var(--font-h)', fontSize: '1.4rem', fontWeight: 700, color: pct >= 80 ? 'var(--primary-r)' : 'var(--alert-r)', lineHeight: 1 }}>{pct}%</div>
                    <div style={{ fontFamily: 'var(--font-m)', fontSize: '.65rem', color: 'var(--muted-r)', marginTop: 2 }}>{pillar.done}/{pillar.total}</div>
                  </div>
                </div>
                <div className="r-progress-bar" style={{ marginBottom: 14 }}>
                  <div className="r-progress-fill" style={{ width: `${pct}%` }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  {p.done.map((item, i) => (
                    <div key={i} style={{ display: 'flex', gap: 8, padding: '3px 0', fontSize: '.8rem', borderBottom: '1px solid rgba(26,29,46,.4)' }}>
                      <span style={{ color: 'var(--primary-r)', fontFamily: 'var(--font-m)', flexShrink: 0 }}>✓</span>
                      <span style={{ color: 'var(--text-r)' }}>{item}</span>
                    </div>
                  ))}
                </div>
                {p.pending.length > 0 && (
                  <div style={{ borderTop: '1px solid var(--border-r)', paddingTop: 8 }}>
                    <div style={{ fontFamily: 'var(--font-m)', fontSize: '.62rem', color: 'var(--muted-r)', letterSpacing: '.1em', textTransform: 'uppercase', marginBottom: 6 }}>Próximo</div>
                    {p.pending.map((item, i) => (
                      <div key={i} style={{ display: 'flex', gap: 8, padding: '3px 0', fontSize: '.78rem', color: 'var(--muted-r)' }}>
                        <span style={{ color: 'var(--border-r)', fontFamily: 'var(--font-m)', flexShrink: 0 }}>○</span>
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )
          })}
        </div>
        <div className="r-callout green" style={{ marginTop: 16 }}>
          20+ ambientes WordPress · 11 fases · {totalLedger}+ entregas rastreadas · Set/2025–Jun/2026
        </div>
      </div>
    </div>
  )
}

export default function RelatorioBlips() {
  const [activePhase, setActivePhase] = useState<number | null>(null)
  const [mode, setMode] = useState<'full' | 'compact'>('full')

  useEffect(() => {
    document.title = 'Blips — Relatório de Entregas · Set/2025–Jun/2026'
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, nofollow'
    document.head.appendChild(meta)
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = 'https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600&family=IBM+Plex+Sans:ital,wght@0,400;0,600;1,400&family=JetBrains+Mono:wght@400;700&display=swap'
    document.head.appendChild(link)
    return () => {
      document.head.removeChild(meta)
      document.head.removeChild(link)
    }
  }, [])

  const totalLedger = LEDGER.reduce((s, l) => s + l.n, 0)
  const totalDone = PILLARS.reduce((s, p) => s + p.done, 0)
  const totalItems = PILLARS.reduce((s, p) => s + p.total, 0)

  return (
    <div className="r-wrap">
      <style>{STYLES}</style>
      <div className="r-inner">

        {/* HEADER */}
        <div className="r-header">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 16 }}>
            <div>
              <span className="r-tag">Matheus Linhares — Relatório de Entregas</span>
              <h1 className="r-title">BLIPS · Set/2025–Jun/2026</h1>
              <p className="r-subtitle">Atualizado Jun/2026 · {FASES.length} fases · {totalLedger}+ entregas</p>
              <div className="r-confidential">● Uso interno · Confidencial</div>
            </div>
            <div style={{ display: 'flex', gap: 0, border: '1px solid var(--border-r)', borderRadius: 4, overflow: 'hidden', alignSelf: 'flex-start', marginTop: 8 }}>
              <button
                onClick={() => setMode('full')}
                style={{
                  padding: '6px 14px',
                  fontFamily: 'var(--font-m)', fontSize: '.7rem', letterSpacing: '.1em', textTransform: 'uppercase',
                  background: mode === 'full' ? 'var(--primary-r)' : 'transparent',
                  color: mode === 'full' ? '#050508' : 'var(--muted-r)',
                  border: 'none', cursor: 'pointer', transition: 'all .15s',
                }}>
                Completo
              </button>
              <button
                onClick={() => setMode('compact')}
                style={{
                  padding: '6px 14px',
                  fontFamily: 'var(--font-m)', fontSize: '.7rem', letterSpacing: '.1em', textTransform: 'uppercase',
                  background: mode === 'compact' ? 'var(--primary-r)' : 'transparent',
                  color: mode === 'compact' ? '#050508' : 'var(--muted-r)',
                  border: 'none', borderLeft: '1px solid var(--border-r)', cursor: 'pointer', transition: 'all .15s',
                }}>
                Resumido
              </button>
            </div>
          </div>
        </div>

        {mode === 'compact' && <ViewCompact totalLedger={totalLedger} />}

        {mode === 'full' && <>

        {/* KPIs */}
        <div className="r-grid-kpi">
          <div className="r-kpi">
            <div className="r-kpi-val">66.359</div>
            <div className="r-kpi-label">Leads no SSOT</div>
            <div className="r-kpi-sub">era 54.286</div>
            <div className="r-kpi-arrow">↑ +22% via correções</div>
          </div>
          <div className="r-kpi">
            <div className="r-kpi-val">4.200+</div>
            <div className="r-kpi-label">Leads reinseridos</div>
            <div className="r-kpi-sub">via Drip (n8n)</div>
            <div className="r-kpi-arrow">↑ pipeline reativado</div>
          </div>
          <div className="r-kpi">
            <div className="r-kpi-val">9</div>
            <div className="r-kpi-label">Sites WP otimizados</div>
            <div className="r-kpi-sub">LiteSpeed + WebP + GF</div>
            <div className="r-kpi-arrow">↑ CWV sprint concluído</div>
          </div>
          <div className="r-kpi">
            <div className="r-kpi-val">7</div>
            <div className="r-kpi-label">Bugs críticos</div>
            <div className="r-kpi-sub">SSOT, trigger, GF, PHP</div>
            <div className="r-kpi-arrow">↑ encontrados e corrigidos</div>
          </div>
          <div className="r-kpi">
            <div className="r-kpi-val">{totalLedger}+</div>
            <div className="r-kpi-label">Entregas rastreadas</div>
            <div className="r-kpi-sub">desde Set/2025</div>
            <div className="r-kpi-arrow">↑ Trello — dados reais</div>
          </div>
        </div>

        {/* TIMELINE */}
        <div className="r-section">
          <div className="r-section-title">Linha do tempo — o que foi feito</div>
          {FASES.map((f, i) => (
            <div
              key={i}
              className="r-phase"
              style={{ cursor: 'pointer', borderColor: activePhase === i ? 'var(--primary-r)' : '' }}
              onClick={() => setActivePhase(activePhase === i ? null : i)}
            >
              <div className="r-phase-date">{f.date}</div>
              <div className="r-phase-title">{f.title}</div>
              {activePhase === i && (
                <>
                  <div className="r-phase-desc" style={{ marginBottom: 10 }}>{f.desc}</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                    {f.tags.map(t => <span key={t} className="r-badge green">{t}</span>)}
                  </div>
                </>
              )}
              {activePhase !== i && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 6 }}>
                  {f.tags.map(t => <span key={t} className="r-badge green">{t}</span>)}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* PLANO WP */}
        <div className="r-section">
          <div className="r-section-title">Plano WP — Higienização → Padronização → Mensuração → Otimização</div>
          {PILLARS.map(p => {
            const pct = Math.round((p.done / p.total) * 100)
            return (
              <div key={p.num} className="r-pillar">
                <div className="r-panel">
                  <div className="r-pillar-header">
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
                      <span className="r-pillar-num">{p.num}</span>
                      <span className="r-pillar-title">{p.title}</span>
                      <span className="r-pillar-sub">{p.sub}</span>
                    </div>
                    <span className="r-pillar-progress">{p.done}✓ / {p.total} — {pct}%</span>
                  </div>
                  <div className="r-progress-bar">
                    <div className="r-progress-fill" style={{ width: `${pct}%` }} />
                  </div>
                  <div style={{ marginTop: 16, columns: '2 280px', gap: 16 }}>
                    {p.items.map((item, idx) => (
                      <div key={idx} className="r-check-item" style={{ breakInside: 'avoid' }}>
                        {item.done
                          ? <span className="r-check-done">✓</span>
                          : <span className="r-check-pending">○</span>}
                        <span style={{ color: item.done ? 'var(--text-r)' : 'var(--muted-r)', fontSize: '.82rem' }}>
                          {item.text}
                          {item.risk && <span className="r-badge amber" style={{ marginLeft: 6, fontSize: '.6rem' }}>⚠ risco</span>}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          })}
          <div className="r-callout green">
            <strong style={{ color: 'var(--primary-r)' }}>{totalDone} entregas ✓ de {totalItems} mapeadas</strong> ({Math.round((totalDone / totalItems) * 100)}%)
          </div>
        </div>

        {/* LEDGER */}
        <div className="r-section">
          <div className="r-section-title">Ledger de Entregas — Unidades Contabilizáveis (Abr–Jun/2026)</div>
          <div className="r-panel">
            <p style={{ fontSize: '.82rem', color: 'var(--muted-r)', marginBottom: 16, fontFamily: 'var(--font-m)' }}>
              Consolidação por decisão de engenharia (1 MU-plugin = 1 entrega, independente de quantos sites). Fonte: handoffs + backlog Supabase (status concluído).
            </p>
            <table className="r-table">
              <thead>
                <tr><th>#</th><th>Categoria</th><th>Destaques</th><th className="num">Entregas</th></tr>
              </thead>
              <tbody>
                {LEDGER.map(l => (
                  <tr key={l.cat}>
                    <td style={{ color: 'var(--primary-r)', fontFamily: 'var(--font-m)', fontWeight: 700 }}>{l.cat}</td>
                    <td style={{ fontWeight: 600 }}>{l.nome}</td>
                    <td style={{ color: 'var(--muted-r)', fontSize: '.82rem' }}>{l.destaques}</td>
                    <td className="num" style={{ color: 'var(--primary-r)', fontWeight: 700, fontFamily: 'var(--font-m)' }}>{l.n}</td>
                  </tr>
                ))}
                <tr className="hl">
                  <td colSpan={3} style={{ fontFamily: 'var(--font-h)', fontWeight: 700 }}>TOTAL</td>
                  <td className="num" style={{ color: 'var(--primary-r)', fontFamily: 'var(--font-h)', fontWeight: 700, fontSize: '1.1rem' }}>{totalLedger}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="r-callout blue">
            <strong style={{ color: 'var(--secondary-r)' }}>Os "cookies pros designers" (categoria B):</strong> trio de entregas que resolveu o cache poisoning — a admin bar de um editor vazava no cache público. blips-cf-cache-fix.php v2 valida o cookie wordpress_logged_in_ antes de tocar no Vary; LiteSpeed exc_cookies + CF Cache Rule completam o triple-layer.
          </div>
        </div>

        {/* CWV */}
        <div className="r-section">
          <div className="r-section-title">CWV — Continuidade da Observação (Mai/2026)</div>
          <div className="r-panel" style={{ marginBottom: 16 }}>
            <p style={{ fontSize: '.88rem', color: 'var(--muted-r)', marginBottom: 16 }}>
              75% das landing pages melhoraram performance. LCP caiu pela metade nas principais páginas de conversão — reflexo do MU-plugin stack (lcp-fix + yt-facade + preconnect) + CF Cache Rules deployados na Fase 8.
            </p>
            <table className="r-table">
              <thead><tr><th>Métrica</th><th className="num">Antes</th><th className="num">Agora</th><th>Frame</th></tr></thead>
              <tbody>
                {CWV_METRICS.map((r, i) => (
                  <tr key={i}>
                    <td style={{ fontWeight: 600 }}>{r.metrica}</td>
                    <td className="num" style={{ color: 'var(--muted-r)' }}>{r.antes}</td>
                    <td className="num" style={{ color: 'var(--primary-r)', fontWeight: 700 }}>{r.agora}</td>
                    <td style={{ color: 'var(--muted-r)', fontSize: '.82rem' }}>{r.frame}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="r-panel">
            <div style={{ fontFamily: 'var(--font-m)', fontSize: '.7rem', color: 'var(--muted-r)', marginBottom: 12, textTransform: 'uppercase', letterSpacing: '.1em' }}>Top 3 absurdos — mobile score</div>
            <table className="r-table">
              <thead><tr><th>#</th><th>Página</th><th className="num">Antes</th><th className="num">Agora</th><th className="num">LCP</th></tr></thead>
              <tbody>
                {CWV_TOP3.map((r, i) => (
                  <tr key={i}>
                    <td style={{ color: 'var(--primary-r)', fontFamily: 'var(--font-m)', fontWeight: 700 }}>{i + 1}</td>
                    <td style={{ fontSize: '.84rem' }}>{r.page}</td>
                    <td className="num" style={{ color: 'var(--muted-r)' }}>{r.antes}</td>
                    <td className="num" style={{ color: 'var(--primary-r)', fontWeight: 700 }}>{r.agora}</td>
                    <td className="num" style={{ color: 'var(--primary-r)', fontFamily: 'var(--font-m)', fontSize: '.8rem' }}>{r.lcp}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="r-callout amber">
            Tradução pro negócio: LCP saiu de 10s para 4s nas LPs de fitness e food. Com R$107k/mês em fitness, cada 1% de redução de CPC economiza ~R$1.070/mês.
          </div>
        </div>

        {/* VPS AUDIT */}
        <div className="r-section">
          <div className="r-section-title">Auditoria Multi-VPS — Estado Real (15 sites × 5 VPS)</div>
          <div className="r-panel">
            <table className="r-table">
              <thead><tr><th>VPS</th><th>Sites</th><th className="num">WP</th><th className="num">Hardening</th><th>Ação</th></tr></thead>
              <tbody>
                {VPS_AUDIT.map((v, i) => (
                  <tr key={i}>
                    <td style={{ fontFamily: 'var(--font-m)', fontSize: '.8rem' }}>{v.vps}</td>
                    <td style={{ fontSize: '.84rem' }}>{v.sites}</td>
                    <td className="num" style={{ fontFamily: 'var(--font-m)', color: v.wp.includes('⚠') ? 'var(--danger-r)' : 'var(--primary-r)', fontWeight: 700 }}>{v.wp}</td>
                    <td className="num" style={{ fontFamily: 'var(--font-m)', color: parseInt(v.hardening) >= 90 ? 'var(--primary-r)' : 'var(--alert-r)' }}>{v.hardening}</td>
                    <td style={{ fontSize: '.82rem', color: 'var(--muted-r)' }}>{v.acao}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* PRÓXIMO CICLO */}
        <div className="r-section">
          <div className="r-section-title">WordPress Ownership Formal — próximo ciclo</div>
          <div className="r-callout red">
            Sem ownership formal, o risco é concreto: qualquer alteração externa nos 20+ ambientes pode desfazer semanas de trabalho. Um site fora do padrão já custou leads com dado errado no Pipedrive.
          </div>
          <div className="r-grid-2" style={{ marginTop: 16 }}>
            {[
              { n: '1', title: 'Hardening formal — 9 sites', desc: 'blips-security.php + lp-hardening.php. Última camada de segurança. Fecha XML-RPC, headers, REST restrict e FILE_EDIT em todos os ambientes.' },
              { n: '2', title: 'Consolidação de servidores', desc: 'Migrar estetica (blips03→blips01) + promo.ideal (blips02→blips01). Reduz 3 VPS para 1. Pré-requisito: promo.ideal limpo (26→12 plugins).' },
              { n: '3', title: 'SEO técnico estrutural', desc: 'GSC Disavow backlinks tóxicos. Slug policy + 301 redirects. Yoast nos 6 sites. Segmentação Analytics alugar vs financiar.' },
              { n: '4', title: 'Monitoramento contínuo', desc: 'ScanBlips v5 em blips01. Hotjar nos 9 sites (heatmap + session). Mapa URL→form_id atualizado automaticamente.' },
            ].map(p => (
              <div key={p.n} className="r-panel">
                <div style={{ fontFamily: 'var(--font-h)', fontSize: '.7rem', color: 'var(--primary-r)', letterSpacing: '.15em', textTransform: 'uppercase', marginBottom: 8 }}>Prioridade {p.n}</div>
                <div style={{ fontFamily: 'var(--font-h)', fontSize: '.95rem', color: 'var(--text-r)', marginBottom: 8 }}>{p.title}</div>
                <div style={{ fontSize: '.84rem', color: 'var(--muted-r)', lineHeight: 1.6 }}>{p.desc}</div>
              </div>
            ))}
          </div>
        </div>

        </>}

        {/* FOOTER */}
        <div className="r-footer" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, alignItems: 'flex-end' }}>
          <div className="r-person">
            <div className="r-person-name">Matheus Edson</div>
            <div className="r-person-role">Growth Engineer</div>
          </div>
          <div className="r-footer-stamp">
            <div style={{ fontFamily: 'var(--font-h)', fontSize: '1rem', color: 'var(--primary-r)', marginBottom: 8 }}>Ordo ab Chao</div>
            <div>Da desordem de 20+ ambientes — ordem.</div>
            <div style={{ marginTop: 8 }}>{totalLedger} entregas. {FASES.length} fases. Stack sólido.</div>
            <div>Matheus Edson · BLIPS · Jun/2026 · Confidencial</div>
          </div>
        </div>

      </div>
    </div>
  )
}
